<nb-auth-block>
  <h2 class="title">Your email has been confirmed.</h2>
  <small class="form-text sub-title">Please contact your technical contact to approve your account.
  </small>
  <hr>
  <h3>If you haven`t received the email, please try the following:</h3>
  <ul>
    <li>Check your spam or junk mail folders</li>
    <li>Make sure your email client is functioning normally</li>
  </ul>
  <!--<button type="button" class="btn btn-block btn-hero-success">Login</button>-->
  <a class="btn btn-block btn-hero-success" routerLink="#/auth/login"><strong>Login</strong></a>
</nb-auth-block>



// WEBPACK FOOTER //
// ./src/app/pages-crypto/components-crypto/registration-message-crypto/registration-message-crypto.component.html